import { TravelClassType } from '@/src/constants/travelers'
import useRedirectToHome from '@/src/hooks/navigation/useRedirectToHome'
import { DeviceType } from '@/src/types/deviceType'
import { useTranslations } from 'next-intl'
import React from 'react'
import { SrpHeader } from './srpHeader'

interface SrpHeaderWrapperProps {
    from: string
    to: string
    departDate: string
    returnDate: string
    travelers: string // changed from number to string
    travelClass: TravelClassType
    deviceType: DeviceType
    onEditClick: () => void
}

const SrpHeaderWrapper: React.FC<SrpHeaderWrapperProps> = ({
    from,
    to,
    departDate,
    returnDate,
    travelers,
    travelClass,
    deviceType,
    onEditClick
}) => {
    const goToHome = useRedirectToHome()
    const t = useTranslations('common')
    return (
        <SrpHeader
            from={from}
            to={to}
            departDate={departDate}
            returnDate={returnDate}
            travelers={travelers}
            travelClass={travelClass}
            onBackClick={(isReloadRequired: boolean) => {
                goToHome({ isReloadRequired })
            }}
            onEditClick={onEditClick}
            t={t}
        />
    )
}

export { SrpHeaderWrapper }
export default SrpHeaderWrapper
